import { useEffect } from 'react'

export const useDeprecationWarning = (
  deprecated?: boolean,
  message?: string,
) => {
  useEffect(() => {
    if (deprecated) {
      // eslint-disable-next-line no-console
      console.warn(`⚠️ ${message}`)
    }
  }, [deprecated, message])
}
